import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import '../../../Pages/Css/solicitudes.css';
import axios from '../../../utils/axiosConfig';
import FormModalCreateInstalador from '../forms/formModalCreateInstalador';
import ModalBaseSm from '../../modals/modal-base-sm';
import { Col, Row } from 'reactstrap';

const ModalInstaladores = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [cc, setCc] = useState('');               // Identificación
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');   // Teléfono
    const [instaladores, setInstaladores] = useState([]);
    const [idEdit, setIdEdit] = useState(-1);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return instaladores;
        return instaladores.filter(item =>
            Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            )
        );
    }, [instaladores, debouncedTerm]);

    const listarInstaladores = () => {
        axios.post(
            process.env.REACT_APP_SERVER + '/operaciones2/getinstaladores',
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            }
        )
            .then(res => {
                if (res.data.success) {
                    console.log('Instaladores cargados:', res.data.data.recordset);
                    setInstaladores(res.data.data.recordset);
                } else {
                    Swal.fire('Error', 'No se pudo cargar instaladores', 'error');
                }
            })
            .catch(() =>
                Swal.fire('Error', 'Falla de red al cargar lista', 'error')
            );
    };

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        if (dialogOpen) {
            setNombre('');
            setCc('');
            setTelefono('');
            setIdEdit(-1);
        }
    };

    const guardar = ({ nombre, cc, telefono }) => {
        if (!cc.trim() || !nombre.trim() || !telefono.trim()) {
            Swal.fire('Error', 'Debe completar CC, Nombre y Teléfono', 'error');
            return;
        }
        const payloadCreate = {
            NEW: -1,
            CCInstalador: cc,
            NombreInstalador: nombre,
            TelefonoInstalador: telefono,
        };
        console.log('Payload a subir para crear:', payloadCreate);
        axios.post(
            process.env.REACT_APP_SERVER + '/operaciones2/setinstaladores',
            JSON.stringify(payloadCreate),
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            }
        )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                console.log('Instalador guardado:', res.data);
                Swal.fire('Éxito', 'Instalador guardado', 'success');
                listarInstaladores();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() => Swal.fire('Error', 'No se pudo guardar', 'error'));
    };

    const update = ({ nombre, cc, telefono }) => {
        console.log('Actualizando instalador con ID:', idEdit);
        console.log('Datos a actualizar:', { nombre, cc, telefono });
        if (!cc.trim() || !nombre.trim() || !telefono.trim()) {
            Swal.fire('Error', 'Debe completar CC, Nombre y Teléfono', 'error');
            return;
        }
        const payloadUpdate = {
            CCInstalador: cc,
            NombreInstalador: nombre,
            TelefonoInstalador: telefono,
            NEW: idEdit,
        };
        console.log('Payload a subir para actualizar:', payloadUpdate);
        axios.post(
            process.env.REACT_APP_SERVER + '/operaciones2/setinstaladores',
            JSON.stringify(payloadUpdate),
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            }
        )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo actualizar', 'error');
                    return;
                }
                console.log('Instalador actualizado:', res.data);
                Swal.fire('Éxito', 'Instalador actualizado', 'success');
                listarInstaladores();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() => Swal.fire('Error', 'No se pudo actualizar', 'error'));
    };

    const handleSaveOrUpdate = ({ nombre, cc, telefono }) => {
        if (idEdit === -1) {
            guardar({ nombre, cc, telefono });
        } else {
            update({ nombre, cc, telefono });
        }
    };

    const editarInstalador = item => {
        console.log('Editando instalador:', item);
        setCc(item.CCInstalador);
        setNombre(item.NombreInstalador);
        setTelefono(item.TelefonoInstalador);
        setIdEdit(parseInt(item.CCInstalador));
        setDialogOpen(true);
    };

    const borrarInstalador = item => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `Está a punto de eliminar el instalador "${item.CCInstalador}". Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#006699',
        }).then(result => {
            if (result.isConfirmed) {
                axios.post(
                    process.env.REACT_APP_SERVER + `/operaciones2/deleteinstalador`,
                    JSON.stringify({ CCInstalador: item.CCInstalador }),
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                        },
                        withCredentials: true,
                    }
                )
                    .then(() => {
                        Swal.fire(
                            'Eliminado',
                            'El instalador ha sido eliminado.',
                            'success'
                        );
                        listarInstaladores();
                    });
            }
        });
    };

    const limpiarCampos = () => {
        setCc('');
        setNombre('');
        setTelefono('');
        setIdEdit(-1);
    };

    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarInstaladores();
    }, []);

    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nuevo-instalador {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar instalador..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-instalador"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Instalador
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#ffffff', width: '40%' }}>
                                    Nombre
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '30%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Teléfono
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '10%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000' }}>
                                        {item.NombreInstalador || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.TelefonoInstalador || '-'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits)
                                                    editarInstalador(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>{' '}
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                // borrarInstalador(item);
                                            }}
                                        >
                                            <i
                                                className="bx bx-trash"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <ModalBaseSm
                isOpen={dialogOpen}
                title={
                    idEdit === -1
                        ? 'Crear instalador'
                        : 'Editar instalador'
                }
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateInstalador
                        onSave={handleSaveOrUpdate}
                        initialData={{ nombre, cc, telefono }}
                    />
                }
            />
        </>
    );
};

export default ModalInstaladores;
